import * as React from "react";

import queryString from "query-string";
import { useMemo, useState } from 'react';

import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";
import { resetPassword } from '../api/auth';
import { CreateForm } from '../components/form-components';
import { Meta } from "../components/meta";
import { LoginPageWrapper } from '../components/mui-login-page-wrapper';
import { ResetPassword } from "../components/reset-password";
import { userEmailShape } from '../data/form-shapes';
import useWindow from "../hooks/useWindow";

export const Footer = () => {
  return (
    <Typography sx={{ textAlign: 'center' }}>
      Don&apos;t have an account?{' '}
      <span>
        <Link
          to="/sign-up"
          // variant="body2"
          // sx={{ alignSelf: 'center' }}
        >
          Sign up
        </Link>
      </span>{` or `}<span>
        <Link
          to="/login"
          // variant="body2"
          // sx={{ alignSelf: 'center' }}
        >
          Sign in
        </Link>
      </span>
    </Typography>
  )
}

const ResetPasswordPage: React.FC<any> = () => {
  const [pageError, setPageError] = useState<string[]>([]);
  const [showMessage, setShowMessage] = useState(false)

  const _window = useWindow();
  const location = _window.location

  const isNewUser = useMemo(() => {
    const q = queryString.parse(location.search);
    const { newuser } = q;
    return newuser && newuser === 'true'
  }, [location.search])

  const organisationName = useMemo(() => {
    const q = queryString.parse(location.search);
    const { organisation_name } = q;
    return organisation_name || ''
  }, [location.search])

  const isResetPage = useMemo(() => {
    const q = queryString.parse(location.search);
    const { token } = q;
    const queryIsValid = (token && typeof token === 'string')
    return !queryIsValid
  }, [location.search])

  if (isResetPage) {
    return (
      <LoginPageWrapper
        title='Reset password' 
        error={pageError}
        // onSubmit={handleSubmit}
      >
        <>
          <Meta title="Reset password for MetOceanAtlas" />
          {showMessage ?
            <>
              <p>Your password has been reset, please check your inbox for a reset link.</p>
              <Footer />
            </>
          :
          <>
            <p>Enter your account's email address, and we'll send you a link to reset your password.</p>
            <CreateForm
              isModal={false}
              shape={userEmailShape}
              submitButtonLabel="Reset password"
              oneButtonSubmit
              defaultValues={isNewUser ? {organisation_name: organisationName} : null}
              onError={(message) => {
                // setLoading(false)
              }}
              onSuccess={() => {
                setShowMessage(true)
                // setLoading(false)
              }}
              onSubmit={(vals ) => {
                // setLoading(true)
                const {email} = vals 
                return resetPassword({email})
              }}
            />
            <Footer />
          </>
          }
        </>
      </LoginPageWrapper>
    )
  }

  return (
    <LoginPageWrapper
      title={isNewUser ? 'Create a new account' : 'Set a new password' }
      error={pageError}
    >
      <>
        <Meta title="Reset password for MetOceanAtlas" />
        {showMessage ?
          <p>Your password has been updated. Please {" "}
            <Link
              to="/login"
              // variant="body2"
              // sx={{ alignSelf: 'center' }}
            >
              sign in
            </Link> using your new password.</p>
        :
        <>
          {isNewUser && <p>{organisationName ? <>You have been invited to join <strong>"{organisationName}"</strong> account.</> : ``} Please fill in your First name, Last Name and password.</p>}
          <ResetPassword 
            isNewUser={!!isNewUser} 
            onSuccess={() => {
              setShowMessage(true)
            }}
            onError={(err) => {
              setPageError(err)
            }}
          />
          <Footer />
        </>
        }
      </>
    </LoginPageWrapper>
  );
}

export default ResetPasswordPage

export const Head: any = () => <title>Home Page</title>